import { render, staticRenderFns } from "./HistoricoInforme.vue?vue&type=template&id=6da6e1d2&"
import script from "./HistoricoInforme.vue?vue&type=script&lang=ts&"
export * from "./HistoricoInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports